import { ColDef } from "ag-grid-enterprise";
import { GetTdroomAllApiResponse, useGetTdroomAllQuery, useGetTdroomSingleQuery } from "../openapi";
import { Box, Group } from "@mantine/core";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useState } from "react";
import { IObjectId } from "@backend/src/schemas";
import PixBimViewer from "./components/PixBimViewer/PixBimViewer";
import { IPixPolygon } from "./components/PixBimViewer/types";
import { DEVICES_TYPES_SETTINGS } from "./enums";

const Extractedtrainingtata: React.FC = () => {
  const [selectedTdId, setSelectedTdId] = useState<IObjectId | undefined>();
  const { data = [] } = useGetTdroomAllQuery();

  const columns: ColDef<GetTdroomAllApiResponse[number]>[] = [
    {
      field: "_id",
      hide: true,
    },
    {
      field: "roomLongName",
      headerName: "Navn",
      sortable: true,
      filter: true,
    },
    {
      field: "roomNumber",
      headerName: "Romsnr",
      sortable: true,
      filter: true,
    },
  ];
  return (
    <Group h="100%" w="100%" grow>
      <Box h="100%" w="50%" className="ag-theme-quartz">
        <AgGridReact
          columnDefs={columns}
          rowData={data}
          onRowClicked={(e) => setSelectedTdId(e.data?._id as IObjectId)}
          getRowId={(p) => p.data._id}
        />
      </Box>
      <Box h="100%" w="50%">
        {selectedTdId != null && <SingleTdViewer tdroomId={selectedTdId} />}
      </Box>
    </Group>
  );
};

export default Extractedtrainingtata;

const SingleTdViewer: React.FC<{ tdroomId: string }> = ({ tdroomId }) => {
  const { data: tdroom, isSuccess } = useGetTdroomSingleQuery({
    tdroomId: tdroomId,
  });

  const [spacePixPolygon, setSpacePixPolygon] = useState<IPixPolygon | undefined>(undefined);
  const [devicePolygons, setDevicePolygons] = useState<IPixPolygon[] | undefined>(undefined);

  const getTdRoomPolygon = (): IPixPolygon | undefined => {
    if (tdroom == null) {
      return undefined;
    }
    return {
      id: "1",
      points: tdroom.polygon as number[][],
      fillColor: "#ffffff",
      strokeColor: "#000",
      strokeWidth: "10",
      text: {
        values: [tdroom.roomNumber, tdroom.roomLongName ?? "-"],
        color: "#000000",
        fontSize: "50px",
        show: true,
      },
      isMoveable: false,
      tooltip: "",
      isDragSelectable: false,
    };
  };

  const getDevicePolygons = (): IPixPolygon[] | undefined => {
    if (tdroom == null) {
      return undefined;
    }

    const sortedDevices = [...tdroom.devices].sort((a, b) => {
      if (a.deviceCategory === "FURNITURE" && b.deviceCategory !== "FURNITURE") {
        return -1;
      }
      if (a.deviceCategory !== "FURNITURE" && b.deviceCategory === "FURNITURE") {
        return 1;
      }
      return 0;
    });

    return sortedDevices.map((deviceItem) => {
      const color = DEVICES_TYPES_SETTINGS[deviceItem.deviceCategory]?.color || "#000000";
      return {
        id: deviceItem._id as string,
        points: deviceItem.boundingBox as number[][],
        fillColor: color,
        strokeColor: "cyan",
        strokeWidth: "0.05",
        text: {
          show: true,
          values: [],
          color: "black",
          fontSize: "1",
        },
        tooltip: undefined, //, getTooltip(),
        isMoveable: false,
        isDragSelectable: false,
      };
    });
  };

  useEffect(() => {
    if (tdroom != null) {
      setSpacePixPolygon(getTdRoomPolygon());
      setDevicePolygons(getDevicePolygons());
    }
  }, [tdroom]);

  return (
    <Box h="100%" w="100%">
      {/* <h1>qqq</h1> */}
      {spacePixPolygon != null && devicePolygons != null && (
        <PixBimViewer angle={0} paths={[]} polygons={[spacePixPolygon, ...devicePolygons]} />
      )}
    </Box>
  );
};
